export const patientServicesDesktopNavigationContainer = ({ isMediumScreen }: { isMediumScreen: boolean }) => ({
	padding: !isMediumScreen ? '2rem' : 0,
	flex: 1,
	display: 'flex',
	flexDirection: 'column',
});

export const needFurtherAssistanceContainer = ({
	needFurtherAssistanceBgColor,
}: {
	needFurtherAssistanceBgColor?: { xs: string; sm: string };
}) => ({
	display: 'flex',
	backgroundColor: needFurtherAssistanceBgColor,
	paddingTop: '2rem',
	paddingBottom: '2rem',
	justifyContent: 'center',
});
